export class RaporKosulEntity {
    rapor_alan_id!: number;
    kosul_operator_id!: number;
    deger!: any;
    ve_mi!: boolean;
}